import React from 'react';
import PropTypes from 'prop-types';

import type { LicenseState } from 'license/types';
import LicenseStatus from 'license/LicenseStatus';

type Props = {
  status: LicenseState,
}

const StatusCell = ({ status }: Props) => (
  <LicenseStatus status={status} />
);

StatusCell.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusCell;
